webpackJsonp([183328146348521],{

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/404.8770243d.png";

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(67);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _bloomer = __webpack_require__(7);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(69);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ = __webpack_require__(894);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Not found component. */
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    { role: 'main' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'NOT FOUND'
	      )
	    ),
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(
	      _bloomer.Hero,
	      { isSize: 'medium' },
	      _react2.default.createElement(
	        _bloomer.HeroBody,
	        null,
	        _react2.default.createElement(
	          _bloomer.Container,
	          { hasTextAlign: 'centered' },
	          _react2.default.createElement(
	            _bloomer.Title,
	            { isSize: 1 },
	            'NOT FOUND'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _bloomer.Container,
	      { role: 'main' },
	      _react2.default.createElement(
	        _bloomer.Columns,
	        null,
	        _react2.default.createElement(
	          _bloomer.Column,
	          { isSize: 7 },
	          _react2.default.createElement(_bloomer.Image, { isRatio: '1:1', src: _2.default })
	        ),
	        _react2.default.createElement(
	          _bloomer.Column,
	          { isSize: 5 },
	          _react2.default.createElement(
	            _bloomer.Content,
	            { isSize: 'large' },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Oops!'
	              ),
	              _react2.default.createElement('wbr', null),
	              'The information you were looking for seems to be not this place apparently.'
	            )
	          ),
	          _react2.default.createElement(
	            _bloomer.Content,
	            { isSize: 'medium' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'If you trace again from the ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                'index page'
	              ),
	              ', you may find something!'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-jsx-2382228bb81479ecf11f.js